import { useCallback } from 'react';
import type { IScreensLogging } from 'shared/src/api/types';
import { bridge } from 'shared/src/utils';
import { useAtomicScreen } from '../../AtomicRenderer/context/AtomicScreenContext';

type LogClickUndoFeedbackParams = {
  logging?: IScreensLogging;
  feedbackEventKey: string;
};

export const useLogClickUndoFeedback = () => {
  const screen = useAtomicScreen();

  return useCallback(
    ({ logging, feedbackEventKey }: LogClickUndoFeedbackParams) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_UNDO_FEEDBACK',
        analytics: {
          ...logging?.analytics,
          ...(screen != null && screen !== '' && { SCREEN: screen }),
          FEEDBACK: feedbackEventKey,
        },
        ably_only_log: logging?.ably_only_log,
      });
    },
    [screen],
  );
};
